import { ChangeEmailTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ChangeEmailTrackingSchema: Record<ChangeEmailTrackingPoint, string> = {
  [ChangeEmailTrackingPoint.ChangeEmailSuccessAction]:
    '00150891-c92a-424b-b705-cb1e6ac4e851',
  [ChangeEmailTrackingPoint.ChangeEmailFailAction]:
    'dbef39f6-9a9e-4865-a960-ab5e9c2e3416',
  [ChangeEmailTrackingPoint.ChangeEmailRateLimitPopupImpression]:
    '9adee1cb-f07b-48e8-a39f-556bed178dc4',
};

export const getChangeEmailPageTypeAndSchema = (
  trackingPoint: ChangeEmailTrackingPoint
) => {
  return {
    page_type: PageType.ChangeEmailPage,
    schema: ChangeEmailTrackingSchema[trackingPoint],
  };
};
